import { useState } from "react";
import { Flag } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { useApi } from "../../lib/useApi";
import { api, formatApiError } from "../../lib/api";
import { REPORT_FIELD, REPORT_STATUS, REPORT_STATUS_TONE } from "../../lib/directoryLabels";

const Report = ({ r, onDone, onLocate }) => {
  const [note, setNote] = useState("");
  const open = ["ouvert", "a_corriger"].includes(r.status);
  const done = async () => {
    try { await api.post(`/company/location-reports/${r.id}/corrected`, { note }); toast.success("Signalement marqué comme corrigé"); onDone(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <li className="space-y-2 p-4" data-testid={`company-report-${r.id}`}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-sm font-medium">{r.agency?.name || "Agence supprimée"} · <span className="text-slate-500">{r.fields.map((f) => REPORT_FIELD[f]).join(", ")}</span></p>
        <span className={`rounded-full px-2 py-0.5 text-[11px] ${REPORT_STATUS_TONE[r.status]}`} data-testid={`company-report-status-${r.id}`}>{REPORT_STATUS[r.status]}</span>
      </div>
      <p className="text-sm text-slate-600">« {r.comment} »</p>
      {r.suggested_latitude != null && <p className="text-xs text-slate-500">Position suggérée : <span className="font-mono">{r.suggested_latitude}, {r.suggested_longitude}</span></p>}
      {r.admin_note && <p className="text-xs text-indigo-700">VOXA AFRIKA : {r.admin_note}</p>}
      {open && (
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end">
          <Textarea rows={1} value={note} onChange={(e) => setNote(e.target.value)} placeholder="Ce que vous avez corrigé" className="flex-1" data-testid={`company-report-note-${r.id}`} />
          {r.agency && <Button variant="outline" size="sm" onClick={() => onLocate(r.agency.id)} data-testid={`company-report-locate-${r.id}`}>Corriger la position</Button>}
          <Button size="sm" disabled={note.trim().length < 2} onClick={done} data-testid={`company-report-done-${r.id}`}>Marquer comme corrigé</Button>
        </div>
      )}
    </li>
  );
};

export default function LocationReports({ onLocate, refreshKey }) {
  const { data, reload } = useApi(`/company/location-reports?k=${refreshKey}`);
  const [all, setAll] = useState(false);
  if (!data?.length) { return null; }
  const pending = data.filter((r) => ["ouvert", "a_corriger"].includes(r.status));
  const rows = all ? data : pending;
  return (
    <div className="card-surface mb-6" data-testid="company-location-reports">
      <div className="flex items-center justify-between gap-2 border-b border-slate-100 p-4">
        <p className="flex items-center gap-2 font-display font-semibold"><Flag className="h-4 w-4 text-amber-600" />Informations signalées comme incorrectes ({pending.length} à traiter)</p>
        <Button variant="ghost" size="sm" onClick={() => setAll(!all)} data-testid="company-reports-toggle">{all ? "À traiter uniquement" : "Tout l'historique"}</Button>
      </div>
      {!rows.length ? <p className="p-4 text-sm text-slate-500">Aucun signalement à traiter.</p> :
        <ul className="divide-y divide-slate-100">{rows.map((r) => <Report key={r.id} r={r} onDone={reload} onLocate={onLocate} />)}</ul>}
    </div>
  );
}
